<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1">{{ data1['druidParamName'] }}<em v-if="data1['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data1['price'] }}</span></div>
        <div class="data2">{{ `${data2['druidParamName']}` }}<em v-if="data2['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data2['price'] }}</span>
        </div>
        <div class="data3">{{ `${data3['druidParamName']}` }}<em v-if="data3['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data3['price'] }}</span>
        </div>
        <div class="data4">{{ `${data4['druidParamName']}` }}<em v-if="data4['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data4['price'] }}</span>
        </div>
        <div class="data5">{{ `${data5['druidParamName']}` }}<em v-if="data5['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data5['price'] }}</span>
        </div>
        <div class="data6">{{ `${data6['druidParamName']}` }}<em v-if="data6['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data6['price'] }}</span>
        </div>
        <div class="data7">{{ `${data7['druidParamName']}` }}<em v-if="data7['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data7['price'] }}</span>
        </div>
        <div class="data8">{{ `${data8['druidParamName']}` }}<em v-if="data8['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data8['price'] }}</span>
        </div>
        <div class="differPrice1 redColor" v-if="chainPrice['differPrice1'] > 0">
          {{ '+' + chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1 greenColor" v-if="chainPrice['differPrice1'] < 0">{{ chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">—</div>
        <div class="differPrice2 redColor" v-if="chainPrice['differPrice2'] > 0">
          {{ '+' + chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2 greenColor" v-if="chainPrice['differPrice2'] < 0">{{ chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">—</div>
        <div class="differPrice3 redColor" v-if="chainPrice['differPrice3'] > 0">
          {{ '+' + chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3 greenColor" v-if="chainPrice['differPrice3'] < 0">{{ chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">—</div>
        <div class="differPrice4 redColor" v-if="chainPrice['differPrice4'] > 0">
          {{ '+' + chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4 greenColor" v-if="chainPrice['differPrice4'] < 0">{{ chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">—</div>
        <div class="differPrice5 redColor" v-if="chainPrice['differPrice5'] > 0">
          {{ '+' + chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5 greenColor" v-if="chainPrice['differPrice5'] < 0">{{ chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5" v-if="chainPrice['differPrice5'] === 0">—</div>
        <div class="differPrice6 redColor" v-if="chainPrice['differPrice6'] > 0">
          {{ '+' + chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6 greenColor" v-if="chainPrice['differPrice6'] < 0">{{ chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6" v-if="chainPrice['differPrice6'] === 0">—</div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div class="title-write" @mouseover="changeFlag(5)" @click="toTwoPage('/powerCoal/twoPage/industry', '5')"
               :class="{'title-write-red' : industryFlag===5}">煤炭快讯
          </div>
          <div class="title-write" @mouseover="changeFlag(4)" @click="toTwoPage('/powerCoal/twoPage/industry', '4')"
               :class="{'title-write-red' : industryFlag===4}">行业要闻
          </div>
          <span class="title-more fr" @click="toTwoPage('/powerCoal/twoPage/industry')">更多 ></span>
        </div>
        <div class="banner-right-content" v-if="industryFlag === 5">
          <ul>
            <li v-for="(item, index) in industryList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/powerCoal/industry', item.id, 5)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
        <div class="banner-right-content" v-else>
          <ul>
            <li v-for="(item, index) in industryListTabs" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/powerCoal/industry', item.id, 4)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li style="position: relative">
          <img src="../../assets/home/meitanqiye.png" alt="">
          <span @click="toTwoPage('/powerCoal/twoPage/enterprise')"
                style="right: 10px;position: absolute;top: 24px;color: #fff;cursor: pointer;"> >></span>
          <img src="../../assets/home/neibu.png" style="position: absolute;left: 183px;width: 70px;top: 24px;" alt="">
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in enterpriseList" :key="index">
              <i></i>
              <p @click="goDetail('/powerCoal/enterprise', item.collectionTime)">
                {{ item.showTimeword + '煤炭重点企业资讯' }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'价格'" :flag="false" :unit="false" :url="'/powerCoal/twoPage/price'"
                                :params="{title:'价格指数',typeList:['产地价格', '港口价格', '进出口价格']}"></ClassificationHeader>
          <div style="border: 1px solid #ccc;border-bottom-left-radius: 4px;border-bottom-right-radius: 4px;">
          <span class="classification-tabs-two" @mouseover="priceFlag = 1"
                @click="reportToPage('/powerCoal/twoPage/price', 'issue_power_coal_place_price')"
                :class="{'priceFlag':priceFlag === 1}" style="vertical-align: top;">产地价格</span>
            <span class="classification-tabs-two" @mouseover="priceFlag = 2"
                  @click="reportToPage('/powerCoal/twoPage/price', 'issue_power_coal_port_price')"
                  :class="{'priceFlag':priceFlag === 2}" style="vertical-align: top;">港口价格</span>
            <!-- <span class="classification-tabs-two" @mouseover="priceFlag = 3"
                  @click="reportToPage('/powerCoal/twoPage/price', 'issue_power_coal_import_price')"
                  :class="{'priceFlag':priceFlag === 3}" style="vertical-align: top;">进口价格</span> -->
            <!-- <span class="classification-tabs-two" @mouseover="priceFlag = 4" @click="reportToPage('/powerCoal/twoPage/price', 'issue_power_coal_import_price')"
                  :class="{'priceFlag':priceFlag === 4}" style="vertical-align: top;">仓单价格</span> -->
            <span class="classification-tabs-two" @mouseover="priceFlag = 5"
                  @click="reportToPage('/powerCoal/twoPage/price', 'issue_power_coal_contract_price')"
                  :class="{'priceFlag':priceFlag === 5}"
                  style="font-size: 12px;height: 34px; padding: 0 10px; width: 104px; line-height: 34px;">期货主力合约价格</span>
            <div class="classification-content" v-if="priceFlag === 1">
              <div class="classification-content-div price priceBgc" v-for="(item, index) in priceOneList" :key="index"
                   @click="goDetail('/powerCoal/priceIndex', item.completeOriginalDate, 'issue_power_coal_place_price')">
                <img src="../../assets/home/jiage.jpg" alt="">
                <p>{{ item.date + '动力煤产地价格' }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="priceFlag === 2">
              <div class="classification-content-div price priceBgc" v-for="(item, index) in priceTwoList" :key="index"
                   @click="goDetail('/powerCoal/priceIndex', item.completeOriginalDate, 'issue_power_coal_port_price')">
                <img src="../../assets/home/jiage.jpg" alt="">
                <p>{{ item.date + '动力煤港口价格' }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="priceFlag === 3">
              <div class="classification-content-div price priceBgc" v-for="(item, index) in priceThreeList"
                   :key="index"
                   @click="goDetail('/powerCoal/priceIndex', item.completeOriginalDate, 'issue_power_coal_import_price')">
                <img src="../../assets/home/jiage.jpg" alt="">
                <p>{{ item.date + '动力煤进口价格' }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="priceFlag === 4">
              <div class="classification-content-div price priceBgc" v-for="(item, index) in priceFourList"
                   :key="index"
                   @click="goDetail('/powerCoal/priceIndex', item.completeOriginalDate, 'issue_power_coal_import_price')">
                <img src="../../assets/home/jiage.jpg" alt="">
                <p>{{ item.date + '动力煤进仓单价格' }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="priceFlag === 5">
              <div class="classification-content-div price priceBgc" v-for="(item, index) in priceFiveList"
                   :key="index"
                   @click="goDetail('/powerCoal/priceIndex', item.completeOriginalDate, 'issue_power_coal_contract_price')">
                <img src="../../assets/home/jiage.jpg" alt="">
                <p>{{ item.date + '动力煤期货主力合约价格' }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <span class="fr" @click="toTwoPage('/powerCoal/twoPage/report')"> >></span>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
            <div class="report-tabs">
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 1}"
                   @click="reportToPage('/powerCoal/twoPage/report', 1)" @mouseover="changeReportFlag(1)">日报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 2}"
                   @click="reportToPage('/powerCoal/twoPage/report', 2)" @mouseover="changeReportFlag(2)">周报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 3}"
                   @click="reportToPage('/powerCoal/twoPage/report', 3)" @mouseover="changeReportFlag(3)">月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img style="width: 360px" src="../../assets/home/yanjiubaogao.png" alt="">
            <div v-if="reportFlag === 1">
              <div class="classification-content-div" v-for="(item, index) in reportList" :key="index"
                   @click="downloadReport(item)">
                <i></i>
                <p style="width: 200px;">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div class="classification-content-div" v-for="(item, index) in reportListWeek" :key="index"
                   @click="downloadReport(item)">
                <i></i>
                <p style="width: 200px;">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div class="classification-content-div" v-for="(item, index) in reportListMonth" :key="index"
                   @click="downloadReport(item)">
                <i></i>
                <p style="width: 200px;">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'产量'" :flag="false" :unit="false" :url="'/powerCoal/twoPage/yield'"
                                :params="{title:'产量',typeList:['原煤产量', '进口量']}"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="yieldFlag = 1"
                @click="toTwoPage('/powerCoal/twoPage/yield', 'issue_power_coal_raw_yield', 2)"
                :class="{'stockFlag':yieldFlag === 1}"
          >原煤产量</span>
          <span class="classification-tabs-three" @mouseover="yieldFlag = 2"
                @click="toTwoPage('/powerCoal/twoPage/yield', 'issue_power_coal_import_yield', 5)"
                :class="{'stockFlag':yieldFlag === 2}"
          >进口量</span>
          <div class="classification-content" v-if="yieldFlag === 1">
            <div class="classification-content-div" v-for="(item, index) in yieldList" :key="index"
                 @click="goDetail('/powerCoal/yield', item.completeOriginalDate, 'issue_power_coal_raw_yield')">
              <i></i>
              <p>{{ item.date + '原煤产量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="yieldFlag === 2">
            <div class="classification-content-div" v-for="(item, index) in yieldListTwo" :key="index"
                 @click="goDetail('/powerCoal/yield', item.completeOriginalDate, 'issue_power_coal_import_yield')">
              <i></i>
              <p>{{ item.date + '动力煤进口量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'库存'" :flag="false" :unit="false" :url="'/powerCoal/twoPage/stock'" :neibu="true"
                                :params="{title:'库存',typeList:['环渤海港口库存', '沿海电厂库存']}"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="stockFlag = 'issue_powercoal_port_stock'"
                @click="toTwoPage('/powerCoal/twoPage/stock', 'issue_powercoal_port_stock', 2)"
                :class="{'stockFlag':stockFlag === 'issue_powercoal_port_stock'}"
          >环渤海港口库存</span>
          <span class="classification-tabs-three" @mouseover="stockFlag = 'issue_powercoal_sea_stock'"
                @click="toTwoPage('/powerCoal/twoPage/stock', 'issue_powercoal_sea_stock', 5)"
                :class="{'stockFlag':stockFlag === 'issue_powercoal_sea_stock'}"
          >沿海电厂库存</span>
          <div class="classification-content" v-if="stockFlag === 'issue_powercoal_port_stock'">
            <div class="classification-content-div" v-for="(item, index) in stockOneList" :key="index"
                 @click="goDetail('/powerCoal/stock', item.completeOriginalDate, 'issue_powercoal_port_stock')">
              <i></i>
              <p>{{ item.date + '动力煤环渤海港口库存' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="stockFlag === 'issue_powercoal_sea_stock'">
            <div class="classification-content-div" v-for="(item, index) in stockTwoList" :key="index"
                 @click="goDetail('/powerCoal/stock', item.completeOriginalDate, 'issue_powercoal_sea_stock')">
              <i></i>
              <p>{{ item.date+ '动力煤沿海电厂库存' }}</p>
              <span class="fr">{{ item.originalDate  }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head">
            <em></em>
            <p>企业分布 <b style="color: #D3131A;font-size: 18px;margin-left: -5px;font-weight: normal">地图</b></p>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
          </div>
          <div class="classification-content" style="margin-top: 5px;">
            <img style="cursor: pointer" src="../../assets/home/map.png" @click="goDetail('/powerCoal/map')" alt="">
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'电厂'" :flag="false" :unit="false" :url="'/powerCoal/twoPage/electric'" :neibu="true"
                                :params="{title:'电厂',typeList:['发电量', '日耗']}"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="yieldFlags = 1"
                @click="toTwoPage('/powerCoal/twoPage/electric', 'issue_power_coal_hair_electric', 2)"
                :class="{'stockFlag':yieldFlags === 1}"
          >发电量</span>
          <span class="classification-tabs-three" @mouseover="yieldFlags = 2"
                @click="toTwoPage('/powerCoal/twoPage/electric', 'issue_powercoal_day_make', 5)"
                :class="{'stockFlag':yieldFlags === 2}"
          >日耗</span>
          <div class="classification-content" v-if="yieldFlags === 1">
            <div class="classification-content-div" v-for="(item, index) in yieldsList" :key="index"
                 @click="goDetail('/powerCoal/electric', item.completeOriginalDate, 'issue_power_coal_hair_electric')">
              <i></i>
              <p>{{ item.date + '动力煤发电量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="yieldFlags === 2">
            <div class="classification-content-div" v-for="(item, index) in yieldsListTwo" :key="index"
                 @click="goDetail('/powerCoal/electric', item.completeOriginalDate, 'issue_powercoal_day_make')">
              <i></i>
              <p>{{ item.date + '动力煤日耗' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li style="position:relative;">
          <ClassificationHeader :name="'技术及标准'" :flag="true" :unit="false" :url="'/powerCoal/twoPage/standard'" :neibu="true"
                                :params="{title:'技术及标准'}"></ClassificationHeader>
          <div class="exitClass">
            <div class="classification-content-div" v-for="(item, index) in standardList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="downloadStandard(item)">{{ item.fileTitle }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="980px" :visible.sync="industrialFlag">
      <CokeIndustrial :chainPrice="chainPrice" :chainTitle="chainTitle" :data1="data1" :data2="data2" :data3="data3"
                      :data4="data4" :data5="data5" :data6="data6" :data7="data7" :data8="data8"
                      @closeIndustrialCh="closeIndustrial"></CokeIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import ClassificationHeader from '@/components/common/ClassificationHeader'
import {
  priceNoAuthList,
  coalImportList,
  coalPlaceList,
  coalPortList,
  coalReceiptList,
  industryNoAuthList,
  reportNoAuthList,
  bulletinList,
  reportDetail,
  addBulletin,
  coalRawYieldList,
  coalImportYieldList,
  industryDetail,
  noAuthHairElectricList, noAuthDayElectricList, mapAuth,standardDetail
} from '@/api/powerCoal'
import {chainList} from '@/api'
import {coalExamineNoAuthList,} from "@/api/coal";
import CokeIndustrial from "@/components/bigChart/cokeIndustrial";

export default {
  name: "index",
  components: {
    ClassificationHeader,
    CokeIndustrial
  },
  data() {
    return {
      industrialFlag: false,
      industryListTabs: [],
      industryFlag: 5,
      show3: false,
      jiaotan: [],
      jiage: [],
      yanjiu: [],
      // 行业动态
      industryList: [],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      standardList: [],
      reportFlag: 2,
      // 价格指数
      priceFlag: 1,
      yieldFlag: 1,
      yieldFlags: 1,
      priceOneList: [],
      priceTwoList: [],
      priceThreeList: [],
      priceFourList: [],
      priceFiveList: [],
      // 库存
      stockFlag: 'issue_powercoal_port_stock',
      enterpriseCapacityFlag: 1,
      stockOneList: [],
      stockTwoList: [],
      stockThreeList: [],
      // 开工率
      rateList: [],
      // 进出口量
      exitFlag: 1,
      exitOneList: [],
      exitTwoList: [],
      // 新增淘汰产能
      boardList: [],
      // 讨论区
      bulletinList: [],
      yieldList: [],
      yieldListTwo: [],
      yieldsList: [],
      yieldsListTwo: [],
      text: '',
      // 产业链
      chainTitle: '',
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      data7: {},
      data8: {},
      chainPrice: {},
      option: {
        title: {
          // text: "ECharts 入门示例"
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ["产量"]
        },
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [
          {
            name: "产量",
            type: "line",
            data: []
          }
        ],
        lineStyle: {
          color: '#F26D77' //改变折线颜色
        },
        grid: {
          x: 40,
          y: 25,
          x2: 10,
          y2: 50
        },
      },
      optionCapacity: {
        title: {
          // text: "ECharts 入门示例"
        },
        tooltip: {},
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [{
          data: [],
          type: 'bar',
          barWidth: 20,//柱图宽度
          itemStyle: {
            normal: {
              color: '#F26D77'
            },
          }
        }],
        grid: {
          x: 60,
          y: 25,
          x2: 10,
          y2: 50
        },
      },
      enterpriseList: [],
    }
  },
  created() {
    this.getHomeList()
    // 动力煤
    for (let i = 0; i < 8; i++) {
      this.jiaotan.push({content: '内容内容内容内容内容内容内容内容内容内容内容内容', time: '08-23'})
    }
    // 价格
    for (let i = 0; i < 7; i++) {
      this.jiage.push({content: '内容内容内容内容内容内容内容内容内容内容内容内容', time: '08-23'})
    }
    // 研究报告
    for (let i = 0; i < 6; i++) {
      this.yanjiu.push({content: '内容内容内容内容内容内容内容内容内容内容内容内容', time: '08-23'})
    }
  },
  methods: {
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     * 切换tabs
     */
    changeFlag(flag) {
      this.industryFlag = flag;
    },
    /**
     * 获取首页信息
     */
    getHomeList() {
      coalExamineNoAuthList({pageNum: 1, pageSize: 7}).then(res => {
        this.enterpriseList = res.rows
      })
      // 产业链
      chainList({dictDataType: 'issue_coal_stell_chain_price'}).then(res => {
        this.chainTitle = res.data['data1']['date'];
        this.data1 = res.data['data1'];
        this.data2 = res.data['data2'];
        this.data3 = res.data['data3'];
        this.data4 = res.data['data4'];
        this.data5 = res.data['data5'];
        this.data6 = res.data['data6'];
        this.data7 = res.data['data7'];
        this.data8 = res.data['data8'];
        this.chainPrice = res.data['price'];
      })
      // 行业动态 1.焦炭，2.钢铁行业动态，3. 钢厂动态，4.煤炭行业要闻，5.煤炭快讯，6.国际钢联粗钢产量，, 7.中钢协冶金进出口、钢铁企业产存，8.宏观-宏观，9.宏观-黑色，10.宏观-化工，11.宏观-环保
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 5}).then(res => {
        this.industryList = res.rows;
        // console.log(this.industryList)
      })
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 4}).then(res => {
        this.industryListTabs = res.rows;
      })
      // 研究报告 1.焦炭，2.钢材，3.煤炭，4.醇醚，5.芳烃，6.碳材料
      this.reportList = [];
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 3, fileType: 1}).then(res => {
        this.reportList = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 3, fileType: 2}).then(res => {
        this.reportListWeek = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 3, fileType: 3}).then(res => {
        this.reportListMonth = res.rows;
      })
      // 技术标准
      reportNoAuthList({pageNum: 1, pageSize: 7, sourceType: 3, fileType: 4}).then(res => {
        this.standardList = res.rows;
      })
      // 价格指数
      coalPlaceList({pageNum: 1, pageSize: 7, dictDataType: 'issue_power_coal_place_price', dataType: 1}).then(res => {
        this.priceOneList = res.rows;
      })
      coalPortList({pageNum: 1, pageSize: 7, dictDataType: 'issue_power_coal_port_price', dataType: 1}).then(res => {
        this.priceTwoList = res.rows;
      })
      coalImportList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_power_coal_import_price',
        dataType: 1
      }).then(res => {
        this.priceThreeList = res.rows;
      })
      coalReceiptList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_power_coal_import_price',
        dataType: 1
      }).then(res => {
        this.priceFourList = res.rows;
      })
      priceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_power_coal_contract_price',
        dataType: 1
      }).then(res => {
        this.priceFiveList = res.rows;
      })
      // 产量
      noAuthDayElectricList({pageNum: 1, pageSize: 7, dictDataType: 'issue_coal_raw_yield', dataType: 2}).then(res => {
        this.yieldList = res.rows;
      })
      coalImportYieldList({pageNum: 1, pageSize: 7, dictDataType: 'issue_coal_import_yield', dataType: 3}).then(res => {
        this.yieldListTwo = res.rows;
      })
      // 电厂
      coalRawYieldList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_power_coal_hair_electric',
        dataType: 2
      }).then(res => {
        this.yieldsList = res.rows;
      })
      noAuthHairElectricList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_powercoal_day_make',
      }).then(res => {
        this.yieldsListTwo = res.rows;
      })
      // 库存
      noAuthHairElectricList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_powercoal_port_stock',
      }).then(res => {
        this.stockOneList = res.rows;
      })
      noAuthHairElectricList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_powercoal_sea_stock',
      }).then(res => {
        this.stockTwoList = res.rows;
      })
    },
    setScroll() {
      setTimeout(() => {
        this.$nextTick(() => {
          const waiceng = document.getElementById('waiceng');
          const neiwaiceng = document.getElementById('neiwaiceng');
          waiceng.scrollTop = neiwaiceng.clientHeight;
        })
      }, 200)
    },
    /**
     * 下载文件
     */
    downloadReport(row) {
      reportDetail(row['id'] + "/1").then((res) => {
        this.$setMenuInfoPath(['动力煤', '研究报告', '正文'], row['id']);
      })
    },
    downloadStandard(row) {
      standardDetail(row['id'] + "/1").then((res) => {
        this.$setMenuInfoPath(['动力煤', '技术及标准', '正文'], row['id']);
      })
    },
    /**
     * 新增讨论区
     */
    addBtn() {
      if (!this.text) {
        this.$message.error('请输入内容')
        return;
      }
      addBulletin({sourceType: 1, speakText: this.text}).then(() => {
        this.$message.success('留言成功！')
        this.text = '';
        bulletinList({sourceType: 1}).then(res => {
          this.bulletinList = res.data;
          this.setScroll()
        })
      })
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag, num) {
      this.$router.push({path: `${url}`, query: {flag, num}});
    },
    reportToPage(url, flag) {
      this.$router.push({path: url, query: {flag}})
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag) {
      this.$router.push({path: `${url}`, query: {id: id, flag: flag}})
      console.log(id)
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item['id'] + "/1").then(() => {
        window.openUrl(item.newsContent)
      })
    },
    goLink() {
      mapAuth().then(() => {
        window.openUrl('http://172.16.100.135:8066/Login/Index3', '_blank');
      })
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 地图配置加载
     */
    drawChart() {
      // 基于准备好的dom，初始化echarts实例【这里存在一个问题，请看到最后】
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // let myChartBalance = this.$echarts.init(document.getElementById("myChartBalance"));
      let myChartCapacity = this.$echarts.init(document.getElementById("myChartCapacity"));
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(this.option);
      // myChartBalance.setOption(optionBalance);
      myChartCapacity.setOption(this.optionCapacity);
    }
  },
}
</script>

<style scoped lang="less">
.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #D3131A;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.priceBgc:nth-child(2n+0) {
  background-color: #f2f2f2;
}

.priceBgc {
  padding: 0 15px;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/steel/banner.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      top: 30px;
      left: 272px;
    }

    .data1 {
      font-size: 10px;
      position: absolute;
      top: 134px;
      left: 29px;
      width: 106px;
      height: 50px;
    }

    .data2 {
      font-size: 10px;
      position: absolute;
      top: 134px;
      left: 179px;
      width: 106px;
      height: 50px;
    }


    .data3 {
      font-size: 4px;
      position: absolute;
      top: 251px;
      left: 176px;
      width: 115px;
      height: 50px;
    }

    .data4 {
      font-size: 10px;
      position: absolute;
      top: 134px;
      left: 345px;
      width: 106px;
      height: 50px;
    }

    .data5 {
      font-size: 10px;
      position: absolute;
      top: 39px;
      right: 20px;
      width: 106px;
      height: 50px;
    }

    .data6 {
      font-size: 10px;
      position: absolute;
      top: 128px;
      right: 20px;
      width: 106px;
      height: 50px;
    }

    .data7 {
      font-size: 10px;
      position: absolute;
      top: 215px;
      right: 20px;
      width: 106px;
      height: 50px;
    }

    .data8 {
      font-size: 10px;
      position: absolute;
      top: 305px;
      right: 18px;
      width: 119px;
      height: 50px;
    }

    .differPrice1 {
      position: absolute;
      top: 131px;
      left: 297px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice2 {
      position: absolute;
      top: 248px;
      left: 303px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice3 {
      position: absolute;
      top: 38px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice4 {
      position: absolute;
      top: 130px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice5 {
      position: absolute;
      top: 210px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice6 {
      position: absolute;
      top: 295px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #333;
        cursor: pointer;
      }

      .title-write-red {
        color: #fff;
        background: #D3131A;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #D3131A;
    border-bottom: 2px solid #D3131A;
  }
}

.tabs-i-hover {
  color: #D3131A;
  border-bottom: 2px solid #D3131A;
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    .last-li {
      border: 1px solid #CCCCCC;
      background: #F2F2F2;
      border-radius: 4px;
      width: 370px;

      .head {
        height: 40px;
        line-height: 40px;
      }

      .classification-content {
        overflow: auto;
        height: 211px;
        border-bottom: 1px solid #ccc;
      }

      .footer {
        height: 44px;
        padding-top: 6px;

        input {
          width: 283px;
          height: 31px;
          background: #FFFFFF;
          border-radius: 4px;
          border: 1px solid #CCCCCC;
          margin-left: 5px;
          padding-left: 10px;
        }

        .btn {
          cursor: pointer;
          display: inline-block;
          width: 61px;
          height: 34px;
          background: #CB081C;
          border-radius: 4px;
          vertical-align: middle;
          color: #fff;
          margin-left: 4px;
          text-align: center;
          line-height: 34px;
        }
      }
    }

    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;

        .red-title {
          width: 168px;
          height: 36px;
          background: #D3131A;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #CCCCCC;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #D3131A;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          width: 44px;
          vertical-align: middle;
          margin-right: 9px;
        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
          position: absolute;
          right: 0;
          top: 2px;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }

      .classification-tabs-two {
        width: 123px;
        height: 34px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        border-top: 2px solid #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .priceFlag {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-two:hover {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-three {
        width: 186px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-tabs-three:hover {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9B857B;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            max-width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {

            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            color: #777777;
            font-size: 12px;
          }

        }

        .price {
          height: 33px;
          line-height: 33px;

          img {
            width: 8px;
            margin-right: 5px;
          }
        }

        .map {
          height: 32px;
          line-height: 32px;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #DDDDDD;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n+0) {
      margin-right: 0;
    }
  }
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
    word-break: break-all
  }
}

.redColor {
  color: #FF6969;
}

.greenColor {
  color: #43E97B;
}
</style>
